import Template from "../../components/Template";
import { useNavigate } from 'react-router-dom';
import { useNavigation } from '../../context/NavigationContext';
import React, { useState, useEffect, useRef } from "react";
import api from "../../services/api";
import config from "../../config";
import * as XLSX from "xlsx";
import AlertDialog from "../../components/AlertDialog";
import { formatCurrencyFromDb, maskCpfCnpj } from "../../utils/masks";
import usePermission from "../../hooks/usePermission";
import FormLabel from "../../components/FormLabel";
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import logoEmpresa from "../../components/logoEmpresaBase64";
import { useAuth } from '../../context/AuthContext';


import useRequisicaoMaisRecente from '../../hooks/useRequisicaoMaisRecente';
const ResumoObras = () => {
    const { auth } = useAuth();
    const navigate = useNavigate();
    const [fornecedores, setFornecedores] = useState([]);
    const [lista, setLista] = useState([]);
    const [statusList, setStatusList] = useState([]);
    const { updateMenu } = useNavigation();
    const [materiais, setMateriais] = useState([]);
    const [obras, setObras] = useState([]);
    const [notasFiscais, setNotasFiscais] = useState([]);
    const [selectedDoc, setSelectedDoc] = useState(null); // Estado para o documento selecionado
    const [showDialog, setShowDialog] = useState(false); // Estado para controlar o modal    
    const [selectedPdf, setSelectedPdf] = useState("");
    const [currentPage, setCurrentPage] = useState(1); // Página atual
    const [pageSize, setPageSize] = useState(10); // Define o tamanho inicial
    const [totalRecords, setTotalRecords] = useState(0); // Total de registros    
    const buttonRef = useRef(null);
    const buttonFiltrarRef = useRef(null);
    const [showSuccessDialog, setShowSuccessDialog] = useState(false);
    const [selectedNotas, setSelectedNotas] = useState([]); // IDs selecionados

    const [filters, setFilters] = useState({
        status: "",
        obra: ""
    });

    const [isSearchActive, setIsSearchActive] = useState(false); // Estado para alternar entre os conteúdos
    const [searchTerm, setSearchTerm] = useState("");
    const [filteredDocumentos, setFilteredDocumentos] = useState([]);
    const [message, setMessage] = useState("");


    useEffect(() => {
        // Quando 'obras' chega, reconstruímos o array de colunas.
        setColumns([
            {
                id: "select",
                label: "", // sem label
                visible: true,
                formatter: (value, doc) => {
                    return (
                        <input
                            type="checkbox"
                            checked={selectedNotas.includes(doc?.id)}
                            onChange={(e) => handleSelectNota(e, doc?.id)}
                        />
                    );
                }
            },
            {
                id: "unidade",
                label: "Unidade",
                visible: true,
                formatter: (value) => value,
            },
            {
                id: "orcamento",
                label: "Valor Orçamento",
                visible: true,
                formatter: (value) => formatCurrencyFromDb(value) || "",
            },
            {
                id: "empenho",
                label: "Empenho",
                visible: true,
                formatter: (value) => value,
            },
            {
                id: "contrato",
                label: "Contrato",
                visible: true,
                formatter: (value) => value,
            },
            {
                id: "statusObra",
                label: "Status da Obra",
                visible: true,
                formatter: (value) => value,
            },
            {
                id: "notaFiscalEmitida",
                label: "Nota Fiscal Emitida",
                visible: true,
                formatter: (value) => formatCurrencyFromDb(value) || "",
            },
            {
                id: "saldo",
                label: "Saldo",
                visible: true,
                formatter: (value) => formatCurrencyFromDb(value) || "",
            },

        ]);
    }, [lista]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [statusRes, obrasRes] = await Promise.all([
                    api.get("/statuses/byModule/nome/obras"),
                    api.get("/obras/listar/todas"),
                ]);
                setStatusList(statusRes.data);
                setObras(obrasRes.data);
            } catch (error) {
                console.error("Erro ao carregar dados:", error);
            }
        };
        fetchData();
    }, []);

    // Somente na montagem. `handlePageChange` ja refaz a busca levando os filtros;
    // quando este effect tambem dependia de `currentPage`, disparava uma segunda
    // requisicao SEM filtro e o resultado exibido virava uma corrida entre as duas.
    useEffect(() => {
        fetchResumoObras(currentPage, pageSize);
    }, []);

    useEffect(() => {
        // Sempre que o termo de pesquisa mudar, atualize os documentos filtrados
        if (searchTerm.trim() === "") {
            setFilteredDocumentos(notasFiscais); // Se não houver termo de pesquisa, mostre todos os documentos
        } else {
            setFilteredDocumentos(
                notasFiscais.filter((doc) =>
                    doc.nomeDocumento.toLowerCase().includes(searchTerm.toLowerCase())
                )
            );
        }
    }, [searchTerm, notasFiscais]);

    // Descarta respostas de filtros que já foram superados por outro mais novo:
    // sem isto, a resposta lenta de um filtro anterior sobrescrevia a tela.
    const requisicaoMaisRecente = useRequisicaoMaisRecente();

    const fetchResumoObras = async (page, size, filtroObra = "", filtroStatus = "") => {
        try {
            // Monta os query params dinamicamente
            let params = `?page=${page}&pageSize=${size}`;
            
            // Só adiciona o filtro se tiver valor válido
            if (filtroObra && filtroObra !== "" && filtroObra !== "undefined" && filtroObra !== "null") {
                params += `&obra=${filtroObra}`;
            }
            if (filtroStatus && filtroStatus !== "" && filtroStatus !== "undefined" && filtroStatus !== "null") {
                params += `&status=${filtroStatus}`;
            }
            
            console.log('Enviando requisição:', `/relatorios/resumo-obras${params}`);
            const idRequisicao = requisicaoMaisRecente.iniciar();
            const response = await api.get(`/relatorios/resumo-obras${params}`);
            // Chegou atrasada e ja foi superada por outro filtro: descarta.
            if (!requisicaoMaisRecente.ehAtual(idRequisicao)) return;

            setLista(response.data.records || []);
            setTotalRecords(response.data.total || 0);
            setPageSize(size);
        } catch (error) {
            console.error("Erro ao carregar dados:", error);
        }
    };

    const fetchFilteredNotasFiscais = async (query) => {
        try {
            const params = new URLSearchParams(query).toString();
            const response = await api.get(`/relatorios/material/comparativo?${params}`);

            setNotasFiscais(response.data.records);
            setTotalRecords(response.data.total);
            setCurrentPage(1);
        } catch (error) {
            console.error("Erro ao aplicar filtros:", error);
        }
    };

    const handleCloseDialog = () => {
        setSelectedDoc(null);
        setShowDialog(false);
    };

    const handleShowPdf = (url) => {
        setSelectedPdf(url);
        setShowDialog(true);
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
        fetchResumoObras(page, pageSize, filters.obra, filters.status);
    };

    const handleSelectNota = (e, notaId) => {
        // Se doc.id for number, garanta que notaId também é number
        const idAsNumber = Number(notaId);
        if (e.target.checked) {
            setSelectedNotas((prev) => [...prev, idAsNumber]);
        } else {
            setSelectedNotas((prev) => prev.filter((id) => id !== idAsNumber));
        }
    };

    const totalPages = Math.ceil(totalRecords / pageSize);
    const startRecord = (currentPage - 1) * pageSize + 1;
    const endRecord = Math.min(currentPage * pageSize, totalRecords);

    // Janela de páginas exibidas
    const pageWindowSize = 5;
    const startPage = Math.max(1, currentPage - Math.floor(pageWindowSize / 2));
    const endPage = Math.min(totalPages, startPage + pageWindowSize - 1);

    const pageNumbers = Array.from(
        { length: endPage - startPage + 1 },
        (_, i) => startPage + i
    );

    const [columns, setColumns] = useState([
        {
            id: "select",
            label: "",
            visible: true,
            formatter: (value, doc) => {
                return (
                    <input
                        type="checkbox"
                        checked={selectedNotas.includes(doc?.id)}
                        onChange={(e) => handleSelectNota(e, doc?.id)}
                    />
                );
            }
        },
        {
            id: "fornecedorNome",
            label: "Fornecedor",
            visible: true,
            formatter: (value) => value,
        },
        {
            id: "fornecedorCnpj",
            label: "CNPJ",
            visible: true,
            formatter: (value) => value ? maskCpfCnpj(value) : "",
        },
        {
            id: "materialDescricao",
            label: "Material",
            visible: true,
            formatter: (value) => value,
        },
        {
            id: "materialCodigoNcm",
            label: "NCM",
            visible: true,
            formatter: (value) => value,
        },
        {
            id: "numeroNotaFiscal",
            label: "Nota Fiscal (Número)",
            visible: true,
            formatter: (value) => value,
        },
        {
            id: "valorUnitario",
            label: "Valor Unitário",
            visible: true,
            formatter: (value) => {
                if (!value) return "";
                // Garante que é número (ou converte string->float)
                const num = parseFloat(value);
                // Formata no padrão PT-BR com 2 casas
                return num.toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL',
                });
            },
        },
    ]);
    const [menuOpen, setMenuOpen] = useState(false);
    const [menuFiltrarOpen, setMenuFiltrarOpen] = useState(false);

    const toggleColumnVisibility = (id) => {
        setColumns((prevColumns) =>
            prevColumns.map((col) =>
                col.id === id ? { ...col, visible: !col.visible } : col
            )
        );
    };

    // Função para fechar o menu ao clicar fora
    const handleClickOutside = (event) => {
        if (
            buttonRef.current &&
            !buttonRef.current.contains(event.target) &&
            buttonFiltrarRef.current &&
            !buttonFiltrarRef.current.contains(event.target)
        ) {
            setMenuOpen(null);
        }
    };

    useEffect(() => {
        if (menuOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);

        };
    }, [menuOpen]);

    const handleMenuClick = (event) => {
        // Impede a propagação do evento para o handleClickOutside
        event.stopPropagation();
    };

    const applyFilters = () => {
        setCurrentPage(1);
        fetchResumoObras(1, pageSize, filters.obra, filters.status);
        setMenuOpen(null); // Fecha o menu de filtro após aplicar
    };

    const clearFilters = () => {
        setFilters({
            status: "",
            obra: ""
        });
        setCurrentPage(1);
        fetchResumoObras(1, pageSize, "", "");
    };

    const handleSearch = () => {
        setCurrentPage(1); // Reinicia para a primeira página
        const query = {
            ...filters,
            page: 1,
            pageSize,
        };
        fetchResumoObras(query); // Executa a busca com o termo atual
    };

    // Função para exportar a tabela
    const exportToExcel = () => {
        if (notasFiscais.length === 0) {
            setMessage('Não há dados para exportar!')
            setShowSuccessDialog(true);
            return;
        }

        // Mapeia os dados da tabela para um formato plano
        const dataToExport = notasFiscais.map((doc) => {
            const row = {};
            columns.forEach((col) => {
                if (col.visible && col.label != 'PDF' && col.label != 'XML') {
                    row[col.label] = col.formatter ? col.formatter(doc[col.id]) : doc[col.id];
                }
            });
            return row;
        });

        // Cria uma nova planilha do Excel
        const worksheet = XLSX.utils.json_to_sheet(dataToExport);

        // Cria um novo workbook
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Materiais por Fornecedores");

        // Exporta o arquivo
        XLSX.writeFile(workbook, "materiaisFornecedores.xlsx");
    };

    const exportarResumoObrasPDF = (lista, logoEmpresa) => {
        const usuarioAtual = auth.user.name;
        const doc = new jsPDF({ orientation: "landscape" });
        let posY = 20;

        // Título
        doc.setFontSize(16);
        doc.text("RESUMO ANDAMENTO OBRAS", 14, posY);
        posY += 10;

        // Monta tabela principal
        const tabelaObras = lista.map((obra) => [
            obra.unidade,
            typeof obra.orcamento === "number"
                ? obra.orcamento.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })
                : obra.orcamento,
            obra.empenho,
            obra.contrato,
            obra.statusObra,
            typeof obra.notaFiscalEmitida === "number"
                ? obra.notaFiscalEmitida.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })
                : obra.notaFiscalEmitida,
            typeof obra.saldo === "number"
                ? obra.saldo.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })
                : obra.saldo,
        ]);

        // Colunas otimizadas para conteúdo
        const columnWidths = [80, 35, 30, 25, 32, 38, 38];

        autoTable(doc, {
            startY: posY,
            head: [[
                'UNIDADE',
                'VALOR ORÇAMENTO',
                'EMPENHO',
                'CONTRATO',
                'STATUS DA OBRA',
                'NOTA FISCAL EMITIDA',
                'SALDO'
            ]],
            body: tabelaObras,
            styles: { fontSize: 10, valign: 'middle' },
            headStyles: {
                fillColor: [30, 120, 180], // Azul
                textColor: 255,
                fontStyle: 'bold'
            },
            alternateRowStyles: { fillColor: [240, 240, 240] }, // cinza claro
            rowStyles: { fillColor: [255, 255, 255] },
            theme: 'striped',
            columnStyles: {
                0: { cellWidth: columnWidths[0] }, // UNIDADE
                1: { cellWidth: columnWidths[1], halign: 'right' }, // VALOR ORÇAMENTO
                2: { cellWidth: columnWidths[2], halign: 'center' }, // EMPENHO
                3: { cellWidth: columnWidths[3] }, // CONTRATO
                4: { cellWidth: columnWidths[4] }, // STATUS DA OBRA
                5: { cellWidth: columnWidths[5], halign: 'right' }, // NOTA FISCAL
                6: { cellWidth: columnWidths[6], halign: 'right' }, // SALDO
            },
            tableWidth: 'auto'
        });

        posY = doc.lastAutoTable.finalY + 12;

        // === Alinhar a tabela totalizadora na mesma largura da tabela principal ===

        // Calcula o total de orçamento
        const totalOrcamento = lista.reduce((acc, cur) => acc + (
            typeof cur.orcamento === "number"
                ? cur.orcamento
                : Number(String(cur.orcamento).replace(/[^\d,.-]/g, "").replace(".", "").replace(",", ".")) || 0
        ), 0);

        const totalOrcamentoFmt = totalOrcamento
            ? totalOrcamento.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })
            : "";

        // Pega largura total da tabela de cima
        const tableWidth = columnWidths.reduce((a, b) => a + b, 0);

        autoTable(doc, {
            startY: posY,
            head: [['DESCRIÇÃO', 'VALOR']],
            body: [
                ['VALOR TOTAL ORÇAMENTO', totalOrcamentoFmt]
            ],
            styles: { fontSize: 11, valign: 'middle' },
            headStyles: {
                fillColor: [30, 120, 180],
                textColor: 255,
                fontStyle: 'bold'
            },
            alternateRowStyles: { fillColor: [240, 240, 240] },
            rowStyles: { fillColor: [255, 255, 255] },
            theme: 'striped',
            tableWidth: tableWidth, // força largura igual à de cima
            margin: { left: 14 },
            columnStyles: {
                0: { cellWidth: tableWidth * 0.7 }, // descrição ocupa ~70%
                1: { cellWidth: tableWidth * 0.3, halign: 'right' }, // valor ocupa ~30%
            }
        });

        // Footer padrão
        const paginas = doc.getNumberOfPages();
        const dataEmissao = new Date().toLocaleString('pt-BR');
        for (let i = 1; i <= paginas; i++) {
            doc.setPage(i);
            doc.setFontSize(8);
            doc.setTextColor(100);
            doc.text(`Emitido por: ${usuarioAtual || "Sistema"}`, 14, 200);
            doc.text(`Data/Hora: ${dataEmissao}`, 14, 205);
            doc.text(`Página ${i} de ${paginas}`, 285, 205, { align: 'right' });
            if (logoEmpresa) {
                const logoWidth = 50, logoHeight = 15, pageWidth = doc.internal.pageSize.getWidth();
                doc.addImage(logoEmpresa, 'PNG', (pageWidth - logoWidth) / 2, 190, logoWidth, logoHeight);
            }
        }

        doc.save("resumo-obras.pdf");
    };

    const exportarResumoObrasExcel = (lista) => {
        // Cabeçalhos conforme PDF
        const headers = [
            "UNIDADE",
            "VALOR ORÇAMENTO",
            "EMPENHO",
            "CONTRATO",
            "STATUS DA OBRA",
            "NOTA FISCAL EMITIDA",
            "SALDO"
        ];

        // Monta linhas de dados, mantendo colunas de valor como number puro
        const data = lista.map((obra) => [
            obra.unidade,
            typeof obra.orcamento === "number"
                ? obra.orcamento
                : Number(String(obra.orcamento).replace(/[^\d,.-]/g, "").replace(".", "").replace(",", ".")) || 0,
            obra.empenho,
            obra.contrato,
            obra.statusObra,
            typeof obra.notaFiscalEmitida === "number"
                ? obra.notaFiscalEmitida
                : Number(String(obra.notaFiscalEmitida).replace(/[^\d,.-]/g, "").replace(".", "").replace(",", ".")) || 0,
            typeof obra.saldo === "number"
                ? obra.saldo
                : Number(String(obra.saldo).replace(/[^\d,.-]/g, "").replace(".", "").replace(",", ".")) || 0,
        ]);

        // Adiciona linha de totalizador no final
        const totalOrcamento = data.reduce((soma, linha) => soma + (linha[1] || 0), 0);

        // Adiciona linha em branco para espaçamento
        data.push(["", "", "", "", "", "", ""]);

        // Linha totalizadora, só coluna VALOR ORÇAMENTO preenchida
        data.push([
            "VALOR TOTAL ORÇAMENTO",
            totalOrcamento,
            "",
            "",
            "",
            "",
            ""
        ]);

        // Monta o array final para planilha (cabeçalho + dados)
        const finalData = [headers, ...data];

        // Cria a planilha
        const ws = XLSX.utils.aoa_to_sheet(finalData);

        // Define formato de moeda para as colunas de valor
        // (Ajuste o range para o número real de linhas do seu relatório)
        const totalLinhas = finalData.length;
        ws["B2"].t = "n"; // Seta explicitamente para número, mas abaixo já define formato para toda a coluna

        // Colunas: B (orcamento), F (nota fiscal emitida), G (saldo)
        // XLSX usa referências tipo "B2:B10"
        // Abaixo, formata todas as linhas exceto o cabeçalho
        for (let i = 2; i <= totalLinhas; i++) {
            ws[`B${i}`] && (ws[`B${i}`].z = 'R$ #,##0.00');
            ws[`F${i}`] && (ws[`F${i}`].z = 'R$ #,##0.00');
            ws[`G${i}`] && (ws[`G${i}`].z = 'R$ #,##0.00');
        }

        // Cria o workbook
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Resumo de Obras");

        // Exporta o arquivo
        XLSX.writeFile(wb, "resumo-obras.xlsx");
    }

    return (
        <Template>
            <div className="h-auto w-full p-4 md:p-8 flex flex-col gap-6">
                <div className="flex flex-wrap justify-between items-center gap-4">
                    <div className="text-stone-800 text-xl md:text-2xl font-medium font-['Inter']">Resumo de Obras</div>
                </div>
                <div className="flex flex-wrap gap-2 md:gap-4 items-center">
                    <div className="flex-grow min-w-0 flex items-center gap-2">
                        <div className="text-stone-600 text-sm font-medium font-['Inter'] leading-tight">Ver</div>
                        <select
                            className="w-20 h-8 pl-2 pr-2 py-1 bg-white rounded-md border border-slate-300 text-sm text-slate-700"
                            value={pageSize} // O valor do tamanho da página atual
                            onChange={(e) => {
                                const newPageSize = parseInt(e.target.value, 10);
                                setPageSize(newPageSize);
                                setCurrentPage(1);
                                fetchResumoObras(1, newPageSize, filters.obra, filters.status);
                            }}
                        >
                            <option value={5}>5</option>
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                        </select>
                        <div className="text-stone-600 text-sm font-medium font-['Inter'] leading-tight">Resultados</div>
                    </div>
                    <div className="flex flex-wrap gap-2 flex-none w-full md:w-auto">
                        <div ref={buttonRef} className="relative justify-end items-center gap-1 flex cursor-pointer" onClick={() => setMenuOpen(menuOpen === "colunas" ? null : "colunas")}>
                            <div className="justify-start items-center gap-2 flex" >
                                <img className="w-6 h-6 relative " src="/images/icon/columns.png" />
                                <div className="text-stone-600 text-sm font-medium font-['Inter'] leading-normal">Colunas</div>
                            </div>
                            <img className="w-6 h-4 px-1 justify-center items-center flex" src="/images/icon/chevron-down.png" />
                            {menuOpen === "colunas" && (
                                <div className="absolute top-full left-0 mt-2 w-48 bg-white border border-gray-300 rounded-md shadow-lg z-50"
                                    style={{
                                        zIndex: 9999, // Garante que está acima de outros elementos
                                    }}
                                    onClick={handleMenuClick} // Impede que o clique feche o menu
                                >
                                    <div className="p-4 flex flex-col gap-3">
                                        {columns.map((col) => (
                                            <div
                                                key={col.id}
                                                className="flex items-center gap-2"
                                            >
                                                <input
                                                    type="checkbox"
                                                    id={col.id}
                                                    checked={col.visible}
                                                    onChange={() =>
                                                        toggleColumnVisibility(col.id)
                                                    }
                                                />
                                                <label
                                                    htmlFor={col.id}
                                                    className="text-sm text-gray-700"
                                                >
                                                    {col.label}
                                                </label>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>
                        <div ref={buttonFiltrarRef} className="relative justify-start items-center gap-1 flex cursor-pointer" onClick={() => setMenuOpen(menuOpen === "filtro" ? null : "filtro")} >
                            <div className="justify-start items-center gap-2 flex">
                                <img className="w-8 h-8 px-0.5 py-[3px] justify-center items-center flex" src="/images/icon/filter.png" />
                                <div className="text-stone-600 text-sm font-medium font-['Inter'] leading-normal">Filtrar</div>
                            </div>
                            <img className="w-6 h-4 px-1 justify-center items-center flex" src="/images/icon/chevron-down.png" />
                            {/* Menu Suspenso */}
                            {menuOpen === "filtro" && (
                                <div
                                    className="absolute top-full left-0 mt-2 w-[350px] bg-white rounded-md shadow-lg z-50 p-4 border border-gray-300"
                                    style={{ zIndex: 9999 }}
                                    onClick={handleMenuClick} // Impede que o clique feche o menu
                                >
                                    <div className="flex flex-col gap-4">
                                        <div className="self-stretch justify-start items-center gap-2.5 inline-flex">
                                            <div className="grow shrink basis-0 text-stone-800 text-xl font-medium">
                                                Filtrar
                                            </div>
                                        </div>

                                        <div className="flex flex-col gap-1.5">
                                            <div className="text-slate-700 text-sm font-medium leading-tight">
                                                Obra
                                            </div>
                                            <select
                                                name="obra"
                                                className="w-full px-3 py-2 bg-white rounded-md border border-slate-300 text-slate-700 text-base"
                                                value={filters.obra}
                                                onChange={(e) =>
                                                    setFilters({ ...filters, obra: e.target.value })
                                                }
                                            >
                                                <option value="">Selecionar</option>
                                                {obras.map((o) => (
                                                    <option key={o.id} value={o.id}>
                                                        {o.nomeProjeto.toUpperCase()}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        <div className="flex flex-col gap-1.5">
                                            <div className="text-slate-700 text-sm font-medium leading-tight">
                                                Status
                                            </div>
                                            <select
                                                name="status"
                                                className="w-full px-3 py-2 bg-white rounded-md border border-slate-300 text-slate-700 text-base"
                                                value={filters.status}
                                                onChange={(e) =>
                                                    setFilters({ ...filters, status: e.target.value })
                                                }
                                            >
                                                <option value="">Selecionar</option>
                                                {statusList.map((s) => (
                                                    <option key={s.id} value={s.id}>
                                                        {s.nome}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>


                                        <div className="self-stretch flex items-center justify-between gap-4 mt-4">
                                            <button
                                                className="px-4 py-2 w-full bg-white rounded-md border border-stone-500 justify-center items-center gap-2 flex"
                                                onClick={clearFilters}
                                            >
                                                <img className="w-4 h-4 relative" src="/images/icon/eraser.png" />
                                                <div className="text-stone-500 text-sm font-medium font-['Inter'] leading-normal" >Limpar</div>
                                            </button>
                                            <button
                                                className="px-4 py-2 w-full bg-stone-600 rounded-md justify-center items-center gap-2 flex"
                                                onClick={applyFilters}
                                            >
                                                <img className="w-4 h-4 relative" src="/images/icon/filter-white.png" />
                                                <div className="text-white text-sm font-medium font-['Inter'] leading-normal" >Filtrar</div>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}

                        </div>
                    </div>
                    <div className="self-stretch flex justify-between gap-4">
                        {usePermission('EXPORTAR_RELATORIOS_RESUMO_OBRAS') && (
                            <>
                                <button type='button' className="px-4 py-2 bg-green-600 text-white text-sm font-medium rounded-md flex items-center gap-2" onClick={() => exportarResumoObrasExcel(lista)}>
                                    <img className="w-4 h-4" src="/images/icon/upload.png" />
                                    <div className="text-white text-sm font-medium font-['Inter'] leading-normal">Resumo Excel</div>
                                </button>
                                <button
                                    type='button' className="flex px-4 py-2 bg-slate-600 rounded-md border border-stone-600 justify-center items-center gap-2 cursor-pointer"
                                    onClick={() => exportarResumoObrasPDF(lista, logoEmpresa)}
                                >
                                    <img className="w-4 h-4" src="/images/icon/pdf.png" />
                                    <div className="text-white text-sm font-medium font-['Inter'] leading-normal">Resumo PDF</div>
                                </button>
                            </>
                        )}
                    </div>
                </div>

                <div className="overflow-x-auto md:overflow-x-visible">
                    <table className="min-w-full bg-white border-collapse border border-gray-200">
                        <thead className="bg-stone-200">
                            <tr>
                                {columns
                                    .filter((col) => col.visible)
                                    .map((col) => (
                                        <th className="px-4 py-2 border border-slate-200 text-slate-800 text-base font-bold">{col.label}</th>
                                    ))}
                            </tr>
                        </thead>
                        <tbody>
                            {lista.map((doc) => (
                                <tr key={doc.id}>
                                    {columns
                                        .filter((col) => col.visible)
                                        .map((col) => (
                                            <td key={`${doc.id}-${col.id}`} className="px-4 py-2 border border-slate-200 text-slate-700 text-base">{col.formatter(doc[col.id], doc)}</td>
                                        ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <div className="self-stretch justify-end items-center gap-2.5 inline-flex">
                    <div className="grow shrink basis-0 text-slate-500 text-base font-normal font-['Inter'] leading-[29.60px]">
                        Mostrando de {startRecord} até {endRecord} de {totalRecords}{" "} registros.
                    </div>
                    <div className="justify-start items-start gap-4 flex">
                        <button
                            className={`w-10 h-10 bg-white/0 rounded border border-[#bebebe] justify-center items-center flex ${currentPage === 1 ? "opacity-50 cursor-not-allowed" : "hover:bg-gray-300 cursor-pointer"
                                }`}
                            disabled={currentPage === 1}
                            onClick={() => handlePageChange(currentPage - 1)}
                        >
                            <img className="w-6 h-6 relative" src="/images/icon/keyboard-arrow-left.png" />
                        </button>

                        {pageNumbers.map((page) => (
                            <button
                                key={page}
                                className={`w-10 h-10 rounded  justify-center items-center flex text-base font-semibold font-['Inter'] ${page === currentPage
                                    ? "bg-stone-600 text-white"
                                    : "bg-gray-200 text-gray-600"
                                    }`}
                                onClick={() => handlePageChange(page)}
                            >
                                {page}
                            </button>
                        ))}
                        <button className={`w-10 h-10 bg-white/0 rounded border border-[#bebebe] justify-center items-center flex 
                        ${currentPage === totalPages ? 'opacity-30 cursor-not-allowed' : 'cursor-pointer'}`}
                            disabled={currentPage === totalPages}
                            onClick={() => handlePageChange(currentPage + 1)}
                        >
                            <img className="w-6 h-6 relative" src="/images/icon/keyboard-arrow-right.png" />
                        </button>
                    </div>
                </div>
                {showDialog && (
                    <div className="fixed top-0 left-0 w-full h-full bg-black/90 z-50 p-10 flex-col justify-start items-end gap-10 inline-flex overflow-hidden">
                        <div className=" rounded-lg w-full max-w-[80%] h-full max-h-[90%] flex flex-col">
                            <div className="flex justify-between items-center p-4">
                                <div className="flex items-center gap-4">
                                    <a href={config.urlArquivo(selectedPdf)} download target="_blank">
                                        <img className="w-6 h-6 relative  overflow-hidden" src="images/icon/download.png" />
                                    </a>
                                    <div className="w-6 h-6 relative  overflow-hidden" />
                                    <div className="w-6 h-6 relative  overflow-hidden" />
                                </div>
                                <img className="w-6 h-6 relative  overflow-hidden cursor-pointer" src="images/icon/x.png" onClick={handleCloseDialog} />
                            </div>
                            <div className="flex-grow flex justify-center items-center p-4 overflow-hidden">
                                <iframe
                                    src={`${config.urlArquivo(selectedPdf)}#toolbar=0`}
                                    className="w-full h-full border-0"
                                    style={{ border: 'none' }}
                                    title="PDF Viewer"
                                />
                            </div>
                        </div>
                    </div>
                )}

                <AlertDialog
                    isVisible={showSuccessDialog}
                    message={message}
                    onClose={() => setShowSuccessDialog(false)}
                />
            </div>
        </Template>
    )
}
export default ResumoObras;